import { isUndefined } from 'lodash';

export default function validatePassingGrade(value) {
  if (isUndefined(value) || !value.toString().length) {
    return 'Empty value';
  }
  return null;
}
